export class AppHelper
{
  static readonly APP_ID = "desk";
}
